<template>
  <span>
    <div v-if="openPopperID != cellData[9]" @click="openPopper(cellData[9])">
      <slot></slot>
    </div>
    <vue-popper
      v-if="openPopperID == cellData[9]"
      :ref="'popper' + cellData[9]"
      trigger="click"
      :boundaries-selector="'#game-' + gameId"
      :options="popperOptions"
      :force-show="true"
      @documentClick="closePopper(cellData[9])"
      @hide="popperHide(cellData[9])"
    >
      <div class="popper history-popper">
        <!-- Header Start -->
        <div class="history-popper-header">
          <Row type="flex" justify="space-between">
            <Col>
              <Row type="flex">
                <b class="history-title">{{ gameTitle }}</b>
              </Row>
              <Row>
                <div
                  class="history-draw-no"
                >{{ $t("general.draw_no") }}{{ gameCode }}{{ cellData[9] }}</div>
              </Row>
            </Col>
            <Col>
              <Row class="history-popper-header-close" type="flex" justify="center" align="middle">
                <Icon type="md-close" size="24" @click="closePopper(cellData[9])" />
              </Row>
            </Col>
          </Row>
        </div>
        <!-- End of Header -->
        <!-- Start of Content -->
        <Row class="history-summary" type="flex">
          <Col class="history-summar-cards">
            <Row
              class="history-summary-cards-container"
              type="flex"
              justify="center"
              align="middle"
            >
              <Col class="the-cards">
                <Row>
                  <Col class="history-player-text" :span="10">{{ $t("domino.PLAYER") }}</Col>
                  <Col :span="4">&nbsp;</Col>
                  <Col class="history-banker-text" :span="10">{{ $t("domino.BANKER") }}</Col>
                </Row>
                <Row type="flex" :gutter="8">
                  <Col :span="5" class="current-cards-player-first">
                    <img
                      class="player-result-one"
                      :src="
                        require(`../../../assets/images/domino/${cellData[1]}.png`)
                      "
                      width="100%"
                      alt
                    />
                  </Col>
                  <Col :span="5" class="summary-cards-player-second">
                    <img
                      class="player-result-two"
                      :src="
                        require(`../../../assets/images/domino/${cellData[2]}.png`)
                      "
                      width="100%"
                      alt
                    />
                  </Col>
                  <Col :span="4" class="summary-cards-vs">VS</Col>
                  <Col :span="5" class="summary-cards-banker-first">
                    <img
                      class="player-result-three"
                      :src="
                        require(`../../../assets/images/domino/${cellData[3]}.png`)
                      "
                      width="100%"
                      alt
                    />
                  </Col>
                  <Col :span="5" class="summary-cards-banker-second">
                    <img
                      class="player-result-four"
                      :src="
                        require(`../../../assets/images/domino/${cellData[4]}.png`)
                      "
                      width="100%"
                      alt
                    />
                  </Col>
                </Row>
                <Row>
                  <Col class="history-player-sum" :span="10">{{ cellData[11] }}</Col>
                  <Col :span="4">&nbsp;</Col>
                  <Col class="history-banker-sum" :span="10">{{ cellData[12] }}</Col>
                </Row>
                <Row
                  class="history-summary-result-time"
                  type="flex"
                  justify="center"
                >{{ cellData[10] }}</Row>
              </Col>
            </Row>
            <Row class="domino-result-pb">
              <Col v-if="cellData[0] == 1" :span="24">{{ $t("domino.PLAYER_WIN") }}</Col>
              <Col v-if="cellData[0] == 3" :span="24">{{ $t("domino.BANKER_WIN") }}</Col>
              <Col v-if="cellData[0] == 2" :span="24">{{ $t("domino.TIE") }}</Col>
            </Row>
            <Row class="domino-result-player" :gutter="12">
              <Col v-if="cellData[5] == 4" :span="12">{{ $t("domino.PLAYER_BIG") }}</Col>
              <Col v-if="cellData[5] == 5" :span="12">{{ $t("domino.PLAYER_SMALL") }}</Col>
              <Col v-if="cellData[6] == 6" :span="12">{{ $t("domino.PLAYER_ODD") }}</Col>
              <Col v-if="cellData[6] == 7" :span="12">{{ $t("domino.PLAYER_EVEN") }}</Col>
            </Row>
            <Row class="domino-result-banker" :gutter="12">
              <Col v-if="cellData[7] == 8" :span="12">{{ $t("domino.BANKER_BIG") }}</Col>
              <Col v-if="cellData[7] == 9" :span="12">{{ $t("domino.BANKER_SMALL") }}</Col>
              <Col v-if="cellData[8] == 10" :span="12">{{ $t("domino.BANKER_ODD") }}</Col>
              <Col v-if="cellData[8] == 11" :span="12">{{ $t("domino.BANKER_EVEN") }}</Col>
            </Row>
          </Col>
        </Row>
        <!-- End of Content -->
      </div>
      <div slot="reference" @click="closePopper(cellData[9])">
        <slot></slot>
      </div>
    </vue-popper>
  </span>
</template>

<script>
import VuePopper from "vue-popperjs";
import { Row, Col, Button, Message, Divider, Icon } from "iview";
import { titleCase, snakeCase } from "change-case";
import "vue-popperjs/dist/vue-popper.css";

export default {
  props: ["game", "cellData", "gameCode", "popperId", "gameId", "tableName"],
  components: {
    VuePopper,
    Row,
    Col,
    Icon
  },
  data() {
    return {
      popperOptions: {
        placement: "bottom",
        hide: true,
        modifiers: {
          flip: { behavior: ["bottom"] },
          preventOverflow: { priority: ["left", "right"] }
        },
        removeOnDestroy: true
      },
      openPopperID: ""
    };
  },
  computed: {
    gameTitle() {
      return titleCase(this.tableName);
    },
    gameSnakeCase() {
      return snakeCase(this.game);
    }
  },
  methods: {
    openPopper: function openPopper(a) {
      let vm = this;
      setTimeout(function() {
        vm.openPopperID = a;
      }, 30);
    },
    closePopper: function closePopper(a) {
      this.$refs["popper" + a].doClose();
    },
    popperHide: function popperHide(a) {
      this.$refs["popper" + a].doDestroy(),
        this.openPopperID === a && (this.openPopperID = "");
    }
  }
};
</script>

<style lang="scss" scoped>
.popper {
  cursor: default;
}

.history-popper-header-close{
  cursor: pointer;
}
.history-title {
  text-transform: uppercase;
  color: $hilo-trend-lot-color-1;
  font-size: 14px;
}

.summary-cards-vs {
  margin-top: 30px;
  text-align: center;
  font-weight: bold;
}

.domino-result-pb {
  text-align: center;
  font-weight: bold;
  color: black;
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 6px;
  margin: 15px 6px 15px 6px;
}

.domino-result-player {
  text-align: center;
  margin: 5px;
}

.domino-result-banker {
  text-align: center;
  margin: 5px;
}

.history-popper-header {
  padding: 13px 15px;
  opacity: 0.9;
  font-size: 12px;
  padding-bottom: 0px;
}

.history-summary {
  padding: 13px 15px;
}

.history-player-text {
  color: $hilo-trend-lot-color-1;
  font-weight: 800;
  margin-bottom: 3px;
  text-align: center;
}

.history-banker-text {
  color: $domino-trend-lot-color-2;
  font-weight: 800;
  margin-bottom: 3px;
  text-align: center;
}

.history-player-sum {
  text-align: center;
  color: $hilo-trend-lot-color-1;
  font-weight: 800;
  margin-top: 3px;
}

.history-banker-sum {
  text-align: center;
  color: $domino-trend-lot-color-2;
  font-weight: 800;
  margin-top: 3px;
}

.history-summary-result-time {
  color: #ffffff;
  margin-top: 15px;
}
</style>
